<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getProcessStatistics)" class="refresh-btn">刷新</el-button>
    <div class="wrap count">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getProcessStatistics)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getProcessStatistics, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getProcessStatistics, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/reportProcessing', '员工加工统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 员工加工列表 -->
      <el-table v-loading="loading" :data="processStatisticsList" :max-height="tableHeight" border>
        <el-table-column fixed prop="name" min-width="80" label="员工姓名"/>
        <el-table-column label="熬药数据"> 
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.machineMedicinal.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.machineMedicinal.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.machineMedicinal.recipeDrugNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.machineMedicinal.recipeDrugPrice}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="制膏方数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.fat.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.fat.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.fat.recipeDrugPrice}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.fat.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="制蜜丸数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.beePill.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.beePill.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.beePill.recipeDrugPrice}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.beePill.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="制水丸数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.waterPill.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.waterPill.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.waterPill.recipeDrugPrice}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.waterPill.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="打粗粉数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.thickPowder.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.thickPowder.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.thickPowder.recipeDrugPrice}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.thickPowder.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="打细粉数据">
          <el-table-column  label="处方张数(张)" min-width="110">
            <template slot-scope="scope">{{scope.row.thinPowder.recipeNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工付数(付)" min-width="110">
            <template slot-scope="scope">{{scope.row.thinPowder.recipeDoseNumber}}</template>
          </el-table-column>
          <el-table-column  label="加工金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.thinPowder.recipeDrugPrice}}</template>
          </el-table-column>
          <el-table-column  label="加工重量(克)" min-width="110">
            <template slot-scope="scope">{{scope.row.thinPowder.recipeDrugNumber}}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getProcessStatistics)"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
    </div>
  </div>
</template>

<script lang="js">
import { processStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'StaffProcess',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      processStatisticsList: [], // 员工加工统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getProcessStatistics);
  },
  methods: {
    // 请求所有员工加工统计列表
    async getProcessStatistics() {
      let { rows, code, total } = await processStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.processStatisticsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>